import { gql } from "@apollo/client";

export const GET_INDIVIDUAL_CUSTOMER_INVOICES = gql`
  query getIndividualCustomerInvoices($individualCustomerId: ID, $limit: Int!, $offset: Int!, $filterKey: String, $filterValue: String){
    getIndividualCustomerInvoices(individualCustomerId: $individualCustomerId, limit: $limit, offset: $offset, filterKey: $filterKey, filterValue: $filterValue) {
      rentalAmount
      customerType
      insuranceAmount
      damageAmount
      addonsAmount
      taxAmount
      dueDate
      dueAmount
      lastSent
      booking {
        referenceNumber
      }
      tax {
        amount
        appliedBy
        appliedDate
        code
      }
      dateCreated
      dateUpdated
      createdBy
      updatedBy
      discount {
        appliedBy
        appliedDate
        isPercent
        code
        amount
      }
      invoiceRef
      status
      locked
      invoiceType
      startDate
      endDate
      totalPayableAmount
      confirmedPaidAmount
      confirmedRefundAmount
      otherRefunds
      otherCharges {
        amount
        name
      }
      id
      customer {
        id
        firstName
        lastName
      }
      businessCustomer {
        id
        businessName
        registrationNumber
        VAT
      }
      sageAccountingInvoiceId
      sentToXero
    }
  }
`;